import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-base bg-opacity-80 bg-blue-200" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Researchers")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-sm text-blue-700 underline bg-opacity-40 bg-blue-200" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Whose artifacts are reused (R+)")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "m-1 table-auto text-xs w-full bg-opacity-40 bg-white" }
const _hoisted_11 = { class: "text-left hover:bg-blue-50" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "text-sm text-blue-700 underline bg-opacity-40 bg-blue-200" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Who reuse artifacts (R)")
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { class: "m-1 table-auto text-xs w-full bg-opacity-40 bg-white" }
const _hoisted_21 = { class: "text-left hover:bg-blue-50" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "text-base bg-opacity-80 bg-blue-200 mt-3" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Artifacts")
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "text-sm text-blue-700 underline bg-opacity-40 bg-blue-200" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Most reused (R+)")
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "m-1 table-auto text-xs bg-opacity-40 bg-white" }
const _hoisted_34 = { class: "text-left" }
const _hoisted_35 = { class: "text-sm text-blue-700 underline bg-opacity-40 bg-blue-200" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Most reusing (R)")
const _hoisted_37 = { key: 2 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { key: 3 }
const _hoisted_41 = { class: "m-1 table-auto text-xs bg-opacity-40 bg-white" }
const _hoisted_42 = { class: "text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        class: "float-right",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openResearchers = !$setup.openResearchers))
      }, _toDisplayString($setup.openResearchers ? "🔼" : "🔽"), 1)
    ]),
    ($setup.openResearchers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, [
            _createVNode(_component_router_link, { to: { name: 'reusemetrics' } }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          ($setup.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("table", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.researchers.reused, (p, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass(index % 2 ? 'bg-opacity-80 bg-white' : '')
                    }, [
                      _createElementVNode("td", _hoisted_11, [
                        (p.entry.oRCID != undefined)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: p.entry.oRCID,
                              target: "_new"
                            }, _toDisplayString(p.entry.given) + " " + _toDisplayString(p.entry.family), 9, _hoisted_12))
                          : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(p.entry.given) + " " + _toDisplayString(p.entry.family), 1))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(p.frequency), 1)
                    ], 2))
                  }), 128))
                ])
              ])),
          _createElementVNode("h3", _hoisted_14, [
            _createVNode(_component_router_link, { to: { name: 'reusemetrics' } }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ]),
          ($setup.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("table", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.researchers.reusing, (p, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass(index % 2 ? 'bg-opacity-80 bg-white' : '')
                    }, [
                      _createElementVNode("td", _hoisted_21, [
                        (p.entry.oRCID != undefined)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: p.entry.oRCID,
                              target: "_new"
                            }, _toDisplayString(p.entry.given) + " " + _toDisplayString(p.entry.family), 9, _hoisted_22))
                          : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(p.entry.given) + " " + _toDisplayString(p.entry.family), 1))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(p.frequency), 1)
                    ], 2))
                  }), 128))
                ])
              ]))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h2", _hoisted_24, [
      _hoisted_25,
      _createElementVNode("button", {
        class: "float-right",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openArtifacts = !$setup.openArtifacts))
      }, _toDisplayString($setup.openArtifacts ? "🔼" : "🔽"), 1)
    ]),
    ($setup.openArtifacts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("h3", _hoisted_27, [
            _createVNode(_component_router_link, { to: { name: 'reusemetrics' } }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            })
          ]),
          ($setup.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
            : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("table", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.publications.reused, (p, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass(index % 2 ? 'bg-opacity-80 bg-white' : '')
                    }, [
                      _createElementVNode("td", _hoisted_34, [
                        _createVNode(_component_router_link, {
                          class: "hover:bg-blue-50",
                          to: {
                  name: 'paper',
                  params: {
                  doiPrefix: p.entry.dOI.split('/')[0],
                  doiSuffix: p.entry.dOI.split('/')[1],
                  },
              }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(p.entry.title[0]), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(p.frequency), 1)
                    ], 2))
                  }), 128))
                ])
              ])),
          _createElementVNode("h3", _hoisted_35, [
            _createVNode(_component_router_link, { to: { name: 'reusemetrics' } }, {
              default: _withCtx(() => [
                _hoisted_36
              ]),
              _: 1
            })
          ]),
          ($setup.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
            : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("table", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.publications.reusing, (p, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass(index % 2 ? 'bg-opacity-80 bg-white' : '')
                    }, [
                      _createElementVNode("td", _hoisted_42, [
                        _createVNode(_component_router_link, {
                          class: "hover:bg-blue-50",
                          to: {
                  name: 'paper',
                  params: {
                  doiPrefix: p.entry.dOI.split('/')[0],
                  doiSuffix: p.entry.dOI.split('/')[1],
                  },
              }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(p.entry.title[0]), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(p.frequency), 1)
                    ], 2))
                  }), 128))
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}